import type { BubblePosition } from "./types";

export const FLOATING_EXPANDABLE_BUBBLE_MARGIN = 24;

export const FLOATING_EXPANDABLE_BUBBLE_EDGE_ZONE_THRESHOLD = 0.15;

export const FLOATING_EXPANDABLE_BUBBLE_DRAG_ACTIVATION_DISTANCE = 5;

export const FLOATING_EXPANDABLE_BUBBLE_SNAP_DURATION_MS = 200;

export const FLOATING_EXPANDABLE_BUBBLE_MORPH_DURATION_MS = 200;

export const FLOATING_EXPANDABLE_BUBBLE_RADIUS_OPEN_EASING = "cubic-bezier(0.7, 0, 0.84, 0)";
export const FLOATING_EXPANDABLE_BUBBLE_RADIUS_CLOSE_EASING = "cubic-bezier(0.16, 1, 0.3, 1)";

export const FLOATING_EXPANDABLE_BUBBLE_NAVBAR_WIDTH = 60;

export const FLOATING_EXPANDABLE_BUBBLE_DEFAULT_MIN_PANEL_SIZE = { width: 200, height: 200 };

export const DEFAULT_FLOATING_POSITION: BubblePosition = {
  horizontal: { type: "end", offset: FLOATING_EXPANDABLE_BUBBLE_MARGIN },
  vertical: { type: "end", offset: FLOATING_EXPANDABLE_BUBBLE_MARGIN }
};
